/**
 * URI encode double quotes, escape commas in a string.
 *
 * Primarily intended for making image URLs safe for use in
 * HTML src attributes.
 *
 * @param   {string}  s
 *
 * @return  {string}
 */
export default function escapeImageUrlForSrcAttr(s: string) {
  let _s = s.replace(/"/g, '%22');
  return _s.replace(/,/g, '%2C');
}